export default __webpack_public_path__ + "static/media/ccn.102c7639.png";